import './infogeral.scss'

const infogeral = ({ plano, nls }) => {
  if (!plano) return null

  const obterTipoPlano = () => {
    if (plano.tipo_plano === 'diario') return nls.planTypeDaily
    if (plano.tipo_plano === 'semanal') return nls.planTypeWeekly
    if (plano.tipo_plano === 'mensal') return nls.planTypeMonthly
    return plano.tipo_plano || ''
  }

  const obterCiclo = () => {
    if (plano.ciclo === 'plan') return nls.cyclePlan
    if (plano.ciclo === 'do') return nls.cycleDo
    if (plano.ciclo === 'check') return nls.cycleCheck
    if (plano.ciclo === 'act') return nls.cycleAct
    return plano.ciclo || ''
  }

  const obterConcluido = () => {
    return plano.concluido ? nls.yes : nls.no
  }

  const obterCausa = () => {
    if (plano.causa === 'automatico') return nls.causeAutomatic
    if (plano.causa === 'pivotado') return nls.causePivoted
    if (plano.causa === 'escalonado') return nls.causeEscalated
    return plano.causa || ''
  }

  const obterMotivoConclusao = () => {
    if (!plano.concluido || !plano.motivoconcluido) return null
    return nls[plano.motivoconcluido] || plano.motivoconcluido
  }

  return (
    <div
  className="infogeral"
  data-cy="pdca-plan-detail-general-info"
>
      <div className="infogeral__title">
        {nls.generalInfo.toUpperCase()}
      </div>

      <div className="infogeral__grid">
        <div>
          <span>{nls.planTypeLabel}</span>
          <strong>{obterTipoPlano()}</strong>
        </div>

        <div>
          <span>{nls.completedLabel}</span>
          <strong>{obterConcluido()}</strong>
        </div>

        {plano.concluido && obterMotivoConclusao() && (
          <div>
            <span>{nls.conclusionReasonLabel}</span>
            <strong>{obterMotivoConclusao()}</strong>
          </div>
        )}

        <div>
          <span>{nls.cycleLabel}</span>
          <strong>{obterCiclo()}</strong>
        </div>

        <div>
          <span>{nls.causeLabel}</span>
          <strong>{obterCausa()}</strong>
        </div>

        <div>
          <span>{nls.startDateLabel}</span>
          <strong>{plano.data_inicial}</strong>
        </div>

        {plano.data_final && (
          <div>
            <span>{nls.endDateLabel}</span>
            <strong>{plano.data_final}</strong>
          </div>
        )}
      </div>
    </div>
  )
}

export default infogeral